var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.5H1M5 0L.5 4.5 5 9"
  })));
}

export default __webpack_public_path__ + "6320c0b88a408b93acf604409641fdec.svg";
export { SvgLeftArrow as ReactComponent };